import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 *
 */
class CustomerService {
  /**
   * @param page
   * @param keyword
   * @param orgId
   * @param limit
   * @param customerId
   * @param tenantCustomerId
   * @param tenantId
   * @return {Promise<*>}
   */
  getCustomers = async (keyword, tenantId, page, limit, customerId, accountManagerIds, selectedCustomerIds, excludeCustomerIds, advanceFilters) => {
    let url = `${Constants.CUSTOMERS}?`;
    if (keyword) url += `search_keyword=${keyword}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (customerId) url += `customer_id=${customerId}&`;
    if (accountManagerIds) url += `account_manager_ids=${accountManagerIds}&`;
    if (selectedCustomerIds) url += `selected_customer_ids=${selectedCustomerIds}&`;
    if (excludeCustomerIds) url += `exclude_customer_ids=${excludeCustomerIds}&`;
    if (advanceFilters) url += `advanced_filter=${advanceFilters}&`;
    const customer = await Helpers.get({ url });
    return customer;
  }

  /**
   * @param customerId
   * @param tenantId
   * @return {Promise<*>}
   */
  getCustomerById = async (customerId, tenantId) => {
    const customer = await Helpers.get({
      url: `${Constants.CUSTOMERS}?customer_id=${customerId}&tenant_id=${tenantId}`,
    });
    return customer;
  }

  /**
   *
   * @param payload
   * @return {Promise<void>}
   */
  createCustomer = async (payload) => {
    const createdCustomer = await Helpers.post({
      url: Constants.CUSTOMERS,
      data: payload,
    });
    return createdCustomer;
  }

  /**
   * @param payload
   * @return {Promise<*>}
   */
  updateCustomer = async (payload) => {
    const customer = await Helpers.put({
      url: Constants.CUSTOMERS,
      data: payload,
    });
    return customer;
  }

  getOrgCustomers = async (keyword, page, limit, isArchiveCustomer) => {
    let url = `${Constants.GET_ORG_CUSTOMERS}?`;
    if (keyword) url += `search_keyword=${keyword}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (isArchiveCustomer) url += `is_archive=${isArchiveCustomer}&`;
    const orgCustomer = await Helpers.get({ url });
    return orgCustomer;
  }

  getBulkUploadCustomerMetadata = async () => {
    const url = `${Constants.CUSTOMERS}/bulk-upload/metadata`;
    const bulkUpload = await Helpers.get({
      url,
    });
    return bulkUpload;
  }

  bulkUploadCustomers = async (payload) => {
    const url = `${Constants.CUSTOMERS}/bulk-upload`;
    const data = new FormData();
    data.append('file', payload?.file);
    data.append('column_mapping', JSON.stringify(payload?.columnMapping));
    data.append('tenant_ids', payload?.tenants);

    const bulkUpload = await Helpers.filePost({
      url,
      file: data,
    });
    return bulkUpload;
  }

  bulkUpdateCustomers = async (payload) => {
    const url = `${Constants.CUSTOMERS}/bulk-update`;
    const data = new FormData();
    data.append('file', payload?.file);
    data.append('column_mapping', JSON.stringify(payload?.columnMapping));
    data.append('tenant_ids', payload?.tenants);
    data.append('current_tenant_id', payload.current_tenant_id);

    const bulkUpdate = await Helpers.filePost({
      url,
      file: data,
    });
    return bulkUpdate;
  }

  getTallyCustomers = async (itId, orgId, searchKeyword, selectedCustomer) => {
    let url = `${Constants.GET_TALLY_CUSTOMERS}?`;
    if (itId) url += `it_id=${itId}&`;
    if (orgId) url += `org_id=${orgId}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (selectedCustomer) url += `selected_tally_customer_id=${selectedCustomer}&`;
    const getTallyCustomers = await Helpers.get({ url });
    return getTallyCustomers;
  }
}

export default new CustomerService();
